import type { SportGroup } from '@gd/shared/sport'
import { SPORT_GROUP_LABEL } from '@gd/shared/sport'
import { cn } from '@/lib/cn'

const SPORT_DOT_CLASS: Record<SportGroup, string> = {
  swim: 'bg-sport-swim',
  bike: 'bg-sport-bike',
  run: 'bg-sport-run',
  walk: 'bg-sport-walk',
  strength: 'bg-sport-strength',
  other: 'bg-sport-other',
}

export interface SportBadgeProps {
  sport: SportGroup
  className?: string
  /** Hide the text label, dot only (pair with an aria-label on the parent or VisuallyHidden). */
  dotOnly?: boolean
}

export function SportBadge({ sport, className, dotOnly }: SportBadgeProps) {
  return (
    <span className={cn('inline-flex items-center gap-1.5 text-small text-ink', className)}>
      <span
        className={cn('size-2 shrink-0 rounded-full', SPORT_DOT_CLASS[sport])}
        aria-hidden="true"
      />
      {!dotOnly && SPORT_GROUP_LABEL[sport]}
    </span>
  )
}
